const parameterize = (obj) => (
  Object.keys(obj)
    .map(
      (k) => {
        if (typeof obj[k] === 'object') {
          return `${encodeURIComponent(k)}=${encodeURIComponent(JSON.stringify(obj[k]))}`;
        }
        return `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`;
      }
    )
    .join('&')
);

export default parameterize;
